<template>
    <div>
        <div class="giftcard-details-form vue-form">
            <div class="vue-form-row">
                <vue-input
                    :element="mbwayPhoneNumberField"
                    :key="mbwayPhoneNumberField.id"
                    tabindex=""
                    @blur="updatePhoneNumber(mbwayPhoneNumberField.id, $event.target.value)">
                </vue-input>
            </div>
        </div>
    </div>
</template>

<script src='./mbway.js'></script>